import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import moment from 'moment/moment';
import CustomerDateInput from '../../inputs/customerDateInput/CustomerDateInput';
import useTranslation from '../../../hooks/translation/useTranslation';
import CustomerSelectInput from '../../inputs/customerSelectInput/CustomerSelectInput';
import { useAuth } from '../../../contexts/userContext/userContext';

function ScheduleForm({
  form,
  onFinish,
}) {
  const [stations, setStations] = useState([]);
  const {
    ticketBookingOptions: options,
  } = useAuth();
  const { trans, currentLanguage } = useTranslation();

  useEffect(() => {
    setStations(() => options
      ?.stations
      ?.filter((station) => station?.[`label_${currentLanguage === 'am' ? 'ka' : currentLanguage}`])
      ?.map((station) => (
        {
          id: station.id,
          label: station[`label_${currentLanguage === 'am' ? 'ka' : currentLanguage}`],
          value: station?.station_id || station.id,
        }
      )));
  }, [options?.stations?.length, currentLanguage]);

  return (
    <Form
      form={form}
      onFinish={onFinish}
      className="w-full max-w-[400px]"
      layout="vertical"
    >
      <CustomerSelectInput
        name="startStationId"
        options={stations}
        label={trans('departure_station')}
        className="white-background font-bold"
        allowClear
      />
      <CustomerSelectInput
        name="endStationId"
        options={stations}
        label={trans('arrival_station')}
        className="white-background font-bold"
        allowClear
      />
      <CustomerDateInput
        name="startDate"
        className="flex-[1] flex justify-center"
        defaultValue={new Date()}
        label={trans('departure_date')}
        noError
        form={form}
        maxDate={moment().add(20, 'day').toDate()}
      />
      <button
        type="submit"
        className="bg-primary min-h-[50px] w-full max-h-[60px] border-0 text-white rounded-lg text-base cursor-pointer flex-1"
      >
        {trans('search')}
      </button>
    </Form>
  );
}

export default ScheduleForm;
